module.exports = __webpack_public_path__ + "static/media/03.0cf0b10c.mp3";